"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.functionMap = exports.generatorFunctions = void 0;
const arrays_1 = require("../functions/arrays");
const numbers_1 = require("../functions/numbers");
exports.generatorFunctions = {
    int: (min, max, multipleOf = 1) => {
        const [actualMin, actualMax] = [min, max].sort((a, b) => a - b);
        const minInt = actualMin < 0 ? Math.ceil(actualMin) : Math.floor(actualMin);
        const maxInt = actualMax < 0 ? Math.ceil(actualMax) : Math.floor(actualMax);
        return (0, numbers_1.multiple)({ multipleOf, minInt: 0, maxInt: maxInt - minInt }) + minInt;
    },
    dp: (value, numPlaces) => {
        const numDP = Math.max(0, numPlaces);
        return value.toFixed(numDP);
    },
    sf: (value, numSigFig) => {
        const numSF = Math.max(1, numSigFig);
        return parseFloat(value.toPrecision(numSF)).toString();
    },
    join: (list, separator) => {
        return (0, arrays_1.join)({ list, separator });
    },
    sum: (list, operator) => {
        return (0, arrays_1.sumList)({ list, operator });
    },
    degToRad: (value) => Math.PI / 180 * value,
    radToDeg: (value) => 180 / Math.PI * value,
};
const generatorFunctionMap = {
    'degToRad(': 'Math.PI / 180 * (',
    'radToDeg(': '180 / Math.PI * (',
    'int(': 'generatorFns.int(',
    'dp(': 'generatorFns.dp(',
    'sf(': 'generatorFns.sf(',
    'join(': 'generatorFns.join(',
    'sum(': 'generatorFns.sum(',
};
exports.functionMap = Object.getOwnPropertyNames(Math).reduce((soFar, propName) => {
    // @ts-ignore
    if (typeof Math[propName] === 'function')
        soFar[`${propName}(`] = `Math.${propName}(`;
    return soFar;
}, generatorFunctionMap);
